import * as React from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "@smartrent/ui";

import { useOrgDeviceBreakdown } from "@/api/organization";

import { DeviceBreakdown } from "@/common/devices/DeviceBreakdown";

/**
 * Responsible for fetching the data from the API and passing the data to the GroupDeviceBreakdown component.
 */
export const OrganizationDeviceBreakdownContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const params = useParams<{ organizationId: string }>();
  const { data, isLoading } = useOrgDeviceBreakdown(params.organizationId);

  if (!data) {
    return null;
  }

  return isLoading ? (
    <Skeleton textType="title" />
  ) : (
    <DeviceBreakdown data={data} />
  );
};
